import React, { useState, useEffect } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

// Import layout and page components
import Header from './components/Header';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';
import Preloader from './components/Preloader';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ProjectsPage from './pages/ProjectsPage';

// This is the layout for your public-facing pages.
const AppLayout = () => {
  // --- SIMPLIFIED PRELOADER LOGIC ---
  // The preloader will now always start in a "not loaded" state.
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // This effect now runs once every time the AppLayout is mounted.
    // We have removed the sessionStorage check for simplicity and reliability.
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1500); // Using the 2.0-second timer for the animation
    return () => clearTimeout(timer);
  }, []); // The empty dependency array [] ensures this runs only once on mount.

  return (
    <>
      <AnimatePresence>
        {!isLoaded && <Preloader />}
      </AnimatePresence>

      {isLoaded && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.0 }}
        >
          <Header />
          <main>
            <Outlet /> {/* Renders the current page (e.g., HomePage) */}
          </main>
          <Footer />
          <BackToTopButton />
        </motion.div>
      )}
    </>
  );
};

// The main App component's only job is to define the routes.
export default function App() {
  return (
    <div className="font-sans antialiased bg-white dark:bg-black text-black dark:text-white">
      <Routes>
        {/* All public routes use the AppLayout, which handles the preloader */}
        <Route path="/" element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />}  />
          <Route path="projects" element={<ProjectsPage />} />
        </Route>
        
        {/* The login page is a standalone route with no layout */}
        <Route path="/nugepola" element={<LoginPage />} />

        {/* The admin route is now wrapped directly by your ProtectedRoute component */}
        <Route
          path="/amgammana"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}